<div class="wrapper">
  <aside *ngIf="navigationBar" class="sidebar" style="height:600px;">
    <table class="table table-sm table-reset table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Сигнал</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let rs of signalsList">
          <tr [ngClass]="!isGridRowSelected(rs)? '':'selected-row'" (click)="onGridRowSelected(rs)">
            <td class="icon-col">
              <i class="fa fa-map-marker"></i>
            </td>
            <td class="incident-title">{{rs.title}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </aside>
  <main #map class="map-container" style="height:unset !important"></main>
</div>
